import {
    IonItem,
    IonLabel,
    IonList,
    IonCheckbox,
} from "@ionic/react";
import React, { useEffect, useState } from "react";

interface QuestionData {
    sentence: string;
    correctAnswers: string[]; // Update to handle multiple correct nouns
}


const Prepositions: React.FC = () => {
    const [questions, setQuestions] = useState<QuestionData[]>([]);
    const [selectedOptions, setSelectedOptions] = useState<string[]>([]); // Store multiple selected nouns
    const [currentIndex, setCurrentIndex] = useState(0);
    const [showImage, setShowImage] = useState(false);
    const [error, setError] = useState(false);
    const [words, setWords] = useState<string[]>([]);

    const shuffleArray = (array: any[]) => {
        for (let i = array.length - 1; i > 0; i--) {
            const randomIndex = Math.floor(Math.random() * (i + 1));
            [array[i], array[randomIndex]] = [array[randomIndex], array[i]];
        }
        return array;
    };

    const fetchQuestions = async () => {
        try {
            let data: QuestionData[] = [];

            if (process.env.REACT_APP_DEVELOPMENT !== 'WEB') {
                const response = await fetch(process.env.REACT_APP_API_URL + 'Prepositions.json');
                data = await response.json();
            } else {
                const module = await import('../../../datas/Prepositions.json');
                data = module.default;
            }

            const shuffledQuestions = shuffleArray(data);
            setQuestions(shuffledQuestions);
            const myQuestion = shuffledQuestions[currentIndex]?.sentence.split(".");
            setWords(myQuestion[0].split(" ") || []);
        } catch (error) {
            console.error('Error loading data:', error);
        }
    };

    useEffect(() => {
        fetchQuestions();
        document.title = "Mamas Guidance - Class One - English - Preposition - Choose All Preposition"; // Set page title
    }, []);

    const handleOptionClick = (option: string) => {
        // Toggle the option in the selectedOptions array
        const updatedSelections = selectedOptions.includes(option)
            ? selectedOptions.filter((item) => item !== option) // Remove if already selected
            : [...selectedOptions, option]; // Add if not selected

        setSelectedOptions(updatedSelections);

        const correctAnswers = questions[currentIndex]?.correctAnswers || [];

        // Check if all correct answers are selected
        const isCorrect =
            correctAnswers.every((noun) => updatedSelections.includes(noun)) &&
            updatedSelections.length === correctAnswers.length;

        if (isCorrect) {
            // Automatically move to the next question
            setShowImage(true);
            setTimeout(() => {
                const nextIndex = currentIndex + 1;
                if (nextIndex < questions.length) {
                    setCurrentIndex(nextIndex);
                    const myQuestion = questions[nextIndex]?.sentence.split(".");
                    setWords(myQuestion[0].split(" ") || []);
                    setSelectedOptions([]); // Reset selections
                }
                else {
                    setCurrentIndex(0);
                    fetchQuestions();
                }
                setShowImage(false);
                setError(false);
            }, 3000); // Delay reduced to 3 seconds
        } else {
            setError(false); // Reset error as user continues selecting
        }
    };

    return (
        <>
            <div className="contentPart showCenter commonNoun additionWord" style={{padding: "0%"}}>
                {showImage === false ? (
                    <>
                        <p className="" style={{ fontWeight: "normal" }}>
                            Q. Choose all the prepositions below 
                        </p>
                        <h3 className="mt-2 mb-2">{questions[currentIndex]?.sentence}</h3>
                        <div className="grid-container" style={{marginBottom: "20px"}}>
                            <div className="grid-box optionDiv" style={{display: "block"}}>
                                <IonList className="grid-item-container">
                                    {words.map((option, index) => (
                                        <IonItem
                                            className={`grid-item ${
                                                selectedOptions.includes(option)
                                                    ? questions[currentIndex]?.correctAnswers.includes(option)
                                                        ? "correct"
                                                        : "errorItems"
                                                    : ""
                                            }`}
                                            key={index}
                                        >
                                            <IonCheckbox
                                                slot="start"
                                                checked={selectedOptions.includes(option)}
                                                onIonChange={() => handleOptionClick(option)}
                                            />
                                            <IonLabel>{option}</IonLabel>
                                        </IonItem>
                                    ))}
                                </IonList>
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="contentPart showMiddle">
                            <img
                                style={{ height: "150px" }}
                                className="img-fluid"
                                src={process.env.REACT_APP_WELDONE_LINK}
                            />
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default Prepositions;
